/**
 * CountUp: animate every `.mnhq-stat__value[data-target]` element from 0 to its
 * target when it scrolls into view. Number formatting preserved via toLocaleString.
 * Bails out on prefers-reduced-motion (writes final values directly).
 */
(function () {
    'use strict';

    function init() {
        var nodes = document.querySelectorAll('.mnhq-stat__value[data-target]');
        if (!nodes.length) return;

        var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        function format(n) {
            return Math.round(n).toLocaleString();
        }

        function animate(el) {
            var target = parseInt(el.getAttribute('data-target'), 10) || 0;
            if (prefersReduced) {
                el.textContent = format(target);
                return;
            }
            var start = null;
            var duration = 1400;
            function tick(ts) {
                if (start === null) start = ts;
                var t = Math.min(1, (ts - start) / duration);
                var eased = 1 - Math.pow(1 - t, 3);
                el.textContent = format(target * eased);
                if (t < 1) requestAnimationFrame(tick);
            }
            requestAnimationFrame(tick);
        }

        if (!('IntersectionObserver' in window)) {
            nodes.forEach(animate);
            return;
        }

        var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    animate(entry.target);
                    io.unobserve(entry.target);
                }
            });
        }, { threshold: 0.4 });

        nodes.forEach(function (el) { io.observe(el); });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
